module.exports = __webpack_public_path__ + "static/media/cover.4317501b.png";